import { createApiHandler } from './handler';

const dietTemplates = {
  apiClient: null,
  path: '/admin/diet-templates',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },
  
  // Override getById to add logging
  async getById(id) {
    console.log("dietTemplates.getById called with id:", id);
    console.log("apiClient:", this.apiClient);
    if (!this.apiClient) {
      throw new Error("API client not initialized");
    }
    try {
      const response = await this.apiClient.get(`${this.path}/${id}`);
      console.log("Raw API response:", response);
      return response.data;
    } catch (error) {
      console.error("Error in dietTemplates.getById:", error);
      throw error;
    }
  }
};

export default dietTemplates;